import React                          from 'react';
import { ulCertification as tooltip } from 'pu-data/Tooltips';
import CheckboxComponent              from './CheckboxComponent';

const UlCertification = (props) => {
  const name = 'ul';
  const { parameters } = props
  return (
    <div className="form-group">
      <CheckboxComponent
        name={name}
        inputId={name}
        label="UL Certification"
        groupName={props.groupName}
        tooltip={props.tooltip}
        checked={parameters[name] === '1'}
        onChange={e => props.onChangeParameter(name, e.target.checked ? '1' : '0')} />
    </div>
  );
};

UlCertification.defaultProps = {
  tooltip,
};

export default UlCertification;
